import React from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import CenterDetailsLink from '../../common/components/CenterDetailsLink';
import ClassDetailsLink from '../../common/components/ClassDetailsLink';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import moment from 'moment';
import DeleteButton from '../../common/components/DeleteButton';
import { PaymentTypes } from '../payments/actions';
import Card from '../../common/components/Card';
import ReduxBlockUi from 'react-block-ui/redux';
import utils from '../../common/services/utils';

const View = ({ payment, cancelLesson, blockLessons, unblockLessons, enableUserTimeZone, t }) => {
	const { child, lesson, childLessons } = payment;
	const { term, center, grade } = lesson;

	return <Row>
		<Col xs={12} md={4} className='pull-right'>
			<Card color='purple'>
				<h4><Link to={`/payment-history/${payment.paymentId}/${PaymentTypes.Lesson}`} className='no-decoration'>{t('FO_Payment_Id')}{payment.paymentId}</Link></h4>
				<h4><CenterDetailsLink center={center} /></h4>
				<h4 className='text-muted'>{term && <span>{term.name}</span>}</h4>
				<div style={{ fontSize: 28, marginTop: 10 }}><ClassDetailsLink programItem={lesson} /></div>
				<div style={{ fontSize: 20, marginTop: 10 }}>{child && child.fullName}</div>
				<h5 className='text-muted'>{t(`PaymentTypeEnum_${payment.paymentType}`)}</h5>
			</Card>
		</Col>
		<Col xs={12} md={8}>
			<h3>{t('FO_Payment_ChildLessons')}</h3>
			<ReduxBlockUi block={blockLessons} unblock={unblockLessons}>
				<Table responsive className='table-expanded'>
					<tbody>
						{childLessons.map(lesson => {
							const lessonStart = enableUserTimeZone ? utils.convertToUserTime(lesson.start, center) : moment(lesson.start);
							const lessonEnd = enableUserTimeZone ? utils.convertToUserTime(lesson.end, center) : moment(lesson.end);

							return <tr key={lesson.id}>
								<td>
									{lessonStart.format('dddd')}
								</td>
								<td>
									{lessonStart.format('ll')}
								</td>
								<td>
									{lessonStart.format('LT')} - {lessonEnd.format('LT')}
								</td>
								<td>
									{lesson.canceled && <b className='text-error'>{t('FO_ChildLesson_Canceled')}</b>}
									{lesson.isInTheFuture && !lesson.canceled && lesson.allowParentCancelLesson && <DeleteButton onDelete={() => cancelLesson(lesson.id)}
										label={t('FO_ChildLesson_CannotAttend')}
										confirmationTitle={t('FO_ChildLesson_CannotAttendConfirmationTitle')}
										confirmationMessage={t('FO_ChildLesson_CannotAttendConfirmationMessage', { lessonDate: moment(lesson.start).format('lll') })} />}
									{!lesson.isInTheFuture && !lesson.canceled && <b>
										{lesson.isAttended ? <span className='text-success'>{t('FO_ChildLesson_Attended')}</span> :
											<span className='text-error'>{t('FO_ChildLesson_NotAttended')}</span>}
									</b>}
								</td>
							</tr>
						})}
					</tbody>
				</Table>
			</ReduxBlockUi>
		</Col>
	</Row>;
};

export default withTranslation()(View);